module.exports = __webpack_public_path__ + "static/teleco_24-9c445ddd095d803af00dd31ef746535e.jpg";